import { render, staticRenderFns } from "./ListarAvisos.vue?vue&type=template&id=57513fcc&scoped=true"
import script from "./ListarAvisos.vue?vue&type=script&lang=ts"
export * from "./ListarAvisos.vue?vue&type=script&lang=ts"
import style0 from "./ListarAvisos.vue?vue&type=style&index=0&id=57513fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57513fcc",
  null
  
)

export default component.exports